export * from './types.js';
export * from './services.js';

import type { ModuleDefinition } from '@em-cms/core';

export const moduleConfig = {
  id: 'shop',
  name: 'فروشگاه',
  description: 'مدیریت فروشگاه، محصولات، سفارشات و درگاه‌های پرداخت',
  version: '0.1.0',
  is_core: false,
  requires: [],
  tables: ['cms_products', 'cms_product_categories', 'cms_cart_items', 'cms_orders', 'cms_order_items', 'cms_payments', 'cms_shipping_addresses', 'cms_payment_gateways'],
};

export const productsModule: ModuleDefinition = {
  id: 'shop',
  name: 'فروشگاه',
  description: 'مدیریت فروشگاه، محصولات، سفارشات و درگاه‌های پرداخت',
  version: '0.1.0',
  icon: 'Package',
  category: 'commerce',
  dependencies: [],
  tables: ['cms_products', 'cms_product_categories', 'cms_cart_items', 'cms_orders', 'cms_order_items', 'cms_payments', 'cms_shipping_addresses', 'cms_payment_gateways'],
  adminRoutes: [
    {
      path: '/shop/products',
      component: () => import('./admin/ProductsListPage').then(m => ({ default: m.ProductsListPage })),
      permission: 'shop.read',
      label: 'محصولات',
      icon: 'Package',
    },
    {
      path: '/shop/products/new',
      component: () => import('./admin/ProductEditPage').then(m => ({ default: m.ProductEditPage })),
      permission: 'shop.create',
      label: 'محصول جدید',
      icon: 'Plus',
    },
    {
      path: '/shop/products/edit/:id',
      component: () => import('./admin/ProductEditPage').then(m => ({ default: m.ProductEditPage })),
      permission: 'shop.update',
      label: 'ویرایش محصول',
    },
    {
      path: '/shop/categories',
      component: () => import('./admin/CategoriesPage').then(m => ({ default: m.CategoriesPage })),
      permission: 'shop.manage_categories',
      label: 'دسته‌بندی‌ها',
      icon: 'FolderOpen',
    },
    {
      path: '/shop/settings',
      component: () => import('./admin/SettingsPage').then(m => ({ default: m.ProductSettingsPage })),
      permission: 'shop.manage_settings',
      label: 'تنظیمات فروشگاه',
      icon: 'Settings',
    },
    {
      path: '/shop/woo-import',
      component: () => import('./admin/WooCommerceImportPage').then(m => ({ default: m.WooCommerceImportPage })),
      permission: 'shop.woo_import',
      label: 'واردات WooCommerce',
      icon: 'Download',
    },
  ],
};
